
import { Component } from '@angular/core';
import { VisitOrderStore } from "@visits-store";
import {
    WaitingRoomFiltersComponent
} from "../../visits/waiting-room/waiting-room-filters/waiting-room-filters.component";
import {
    WaitingRoomTableComponent
} from "../../visits/waiting-room/waiting-room-table/waiting-room-table.component";

@Component({
    selector: 'waiting-room',
    imports: [
    WaitingRoomFiltersComponent,
    WaitingRoomTableComponent
],
    providers: [
        VisitOrderStore,
    ],
    templateUrl: './waiting-room.component.html',
    styleUrl: './waiting-room.component.scss'
})

export class WaitingRoomComponent{
}
